"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BluePrintDistribution = void 0;
const StoryEdge_1 = require("../../../storyV2/domain/StoryEdge");
const StoryNodeDisplayType_1 = require("../../../storyV2/domain/StoryNodeDisplayType");
const StoryManagerUtil_1 = require("../../../storyV2/domain/StoryManagerUtil");
const StoryNodeType_1 = require("../../../storyV2/domain/StoryNodeType");
const FunctionBase_1 = require("../../../storyV2/function/FunctionBase");
const StoryNodeState_1 = require("../../../storyV2/domain/StoryNodeState");
const AdapterErrorUtil_1 = require("../../../storyV2/adapter/AdapterErrorUtil");
const StoryNode_1 = require("../../../storyV2/domain/StoryNode");
const JsonUtil_1 = require("../../../cutil/JsonUtil");
const BaseDistribution_1 = require("../../../storyV2/response/responseDistribution/BaseDistribution");
class BluePrintDistribution extends BaseDistribution_1.BaseDistribution {
    handleRunResponse(story, edge, res, relatedEdges, displayType) {
        let targetNode = StoryManagerUtil_1.StoryManagerUtil.getOrCreateOutputNode(story, edge, StoryNodeType_1.StoryNodeType.CUSTOMNODE, StoryNodeDisplayType_1.StoryNodeDisplayType.BLUEPRINT);
        StoryManagerUtil_1.StoryManagerUtil.updateLastEdgeOutnode(story, edge, targetNode);
        if (res.data instanceof FunctionBase_1.RunStreamResponse) {
            return new Promise(executor => {
                const streamResponse = res.data;
                streamResponse.onReceived(result => {
                    targetNode.state = StoryNodeState_1.StoryNodeState.RECEIVING;
                    if (result.error) {
                        const contentString = AdapterErrorUtil_1.AdapterErrorUtil.getErrorMsg(result);
                        targetNode.state = StoryNodeState_1.StoryNodeState.ERROR;
                        targetNode.received(new StoryNode_1.StoryNodeEventObject(contentString));
                        StoryManagerUtil_1.StoryManagerUtil.setEdgesStateAndNotify([edge, ...relatedEdges], StoryEdge_1.EdgeState.ERROR, story);
                        executor();
                        return;
                    }
                    /// 结束edge的run
                    if (result.completion) {
                        targetNode.state = StoryNodeState_1.StoryNodeState.COMPLETED;
                        targetNode.received(new StoryNode_1.StoryNodeEventObject(result.value));
                        StoryManagerUtil_1.StoryManagerUtil.setEdgesStateAndNotify([edge, ...relatedEdges], StoryEdge_1.EdgeState.COMPLETED, story);
                        return executor();
                    }
                    targetNode.received(new StoryNode_1.StoryNodeEventObject(result.value));
                });
            });
        }
        else {
            let contentString = "";
            if (typeof res.data !== "string") {
                contentString = JsonUtil_1.JsonUtil.stringify(res) ?? "";
            }
            targetNode.options.displayType = StoryNodeDisplayType_1.StoryNodeDisplayType.BLUEPRINT;
            targetNode.state = StoryNodeState_1.StoryNodeState.COMPLETED;
            targetNode.cleanChildren();
            targetNode.received(new StoryNode_1.StoryNodeEventObject(contentString));
            StoryManagerUtil_1.StoryManagerUtil.setEdgesStateAndNotify([edge, ...relatedEdges], StoryEdge_1.EdgeState.COMPLETED, story);
            return Promise.resolve();
        }
    }
}
exports.BluePrintDistribution = BluePrintDistribution;
